<template>
<div class="slider_container">
	<div class="slider_arrow_container">
		<button class="slider_button" 
		@click="prevSlide"
		v-if="slide != 1"
		>
		<svg class="prev_button"
         width="5.2100725mm"
         height="5.1902251mm"
         viewBox="0 0 5.2100725 5.1902251">
         <g
         id="layer1"
         transform="translate(-105.73777,-70.332543)">
         <path
         style="fill:#f28116;fill-opacity:1;stroke:#000000;stroke-width:0.39396;stroke-linecap:round;stroke-dasharray:none"
         d="m 107.39328,70.540972 1.92867,-0.01035 -0.0893,2.49387 1.25797,0.06122 -2.18286,2.157551 -2.11539,-2.169314 1.23328,-0.03532 z"
         id="path1" />
         </g>
        </svg>
		</button>
	</div>
	<div class="slide_container">
		<div 
		class="slide"
		:style="{'background-image': 'url(' + currentImage + ')'}"
		>
			
		</div>

	</div>
	<div class="slider_arrow_container">
		<button class="slider_button" 
		v-if="slide != slides"
		@click="nextSlide"
		>
		<svg class="next_button"
         width="5.2100725mm"
         height="5.1902251mm"
         viewBox="0 0 5.2100725 5.1902251">
         <g
         id="layer1"
         transform="translate(-105.73777,-70.332543)">
         <path
         style="fill:#f28116;fill-opacity:1;stroke:#000000;stroke-width:0.39396;stroke-linecap:round;stroke-dasharray:none"
         d="m 107.39328,70.540972 1.92867,-0.01035 -0.0893,2.49387 1.25797,0.06122 -2.18286,2.157551 -2.11539,-2.169314 1.23328,-0.03532 z"
         id="path1" />
         </g>
        </svg>
		</button>
	</div>
</div>
</template>
<script>
// import {showImage} from '@/api/mapItems'
export default {
    name: 'mapDetailSlider',
    props: {
     msg: String,
     images: Object,
     token: String
    },
    data(){
	return {
	currentImage: null,
	slides: 0,
	slide: 1,
	}
	},
	watch: {
	slide(){
		this.slides = Object.keys(this.images).length
		this.currentImage = this.getImage()
	},
	images(){
		this.slides = Object.keys(this.images).length
		this.currentImage = this.getImage()
	},
	},
    methods: {
    getImage(){
        console.log(`http://localhost:5000/map/show_image/${this.images[this.slide]}`)
        return `http://localhost:5000/map/show_image/${this.images[this.slide]}`
    },
    nextSlide(){
        this.slide += 1
        console.log(this.slide)
        if(this.slide > this.slides){
            this.slide = this.slides
    }
    },
    prevSlide(){
    this.slide -= 1
    console.log(this.slide)
    if(this.slide < 1){
    this.slide = 1
    }
    },
    },
    computed: {
    },
    created(){
     this.slides = Object.keys(this.images).length
     console.log(this.slides)
     console.log(this.images)
     this.currentImage = this.getImage()
    }


    
}
</script>